import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { piiProps } from 'src/components/DemoBlur';

const CustomLastNameCell = ({ params }) =>
    <Typography variant="body2" align="center" textAlign='center' sx={{ fontWeight: 400, fontSize: '0.8125rem' }}>
        <span {...piiProps} style={{ textTransform: 'capitalize' }}>{params?.row?.last_name || ''}</span>
    </Typography>;

export default CustomLastNameCell;

CustomLastNameCell.propTypes = {
    params: PropTypes.any,
};